export default {"src":"/pro/_next/static/media/s.10173636.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};